import React, { useContext, useState, useEffect, useRef } from "react";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import * as FaIcons from "react-icons/fa";

const SearchForm = ({ onSearchChange, searchValue = "", placeholderText = "Search by name, email, phone..." }) => {
  const [searchText, setSearchText] = useState(searchValue);
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { getRegistrations, appliedFilters, pageSize, setCurrentPage } = adminRegistrationContext;
  const debounceTimer = useRef(null);
  const isInitialMount = useRef(true);

  // Sync with parent component
  useEffect(() => {
    setSearchText(searchValue);
  }, [searchValue]);

  // Dynamic search with debouncing
  useEffect(() => {
    // Skip on initial mount - let the page handle initial load
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Clear previous timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set new timer for debounced search
    debounceTimer.current = setTimeout(() => {
      // Trigger backend search
      const filters = {
        page: 1,
        pageSize: pageSize || 300,
      };

      // Add existing filters
      if (appliedFilters) {
        if (appliedFilters.status) filters.status = appliedFilters.status;
        if (appliedFilters.learningCenterName) filters.learningCenterName = appliedFilters.learningCenterName;
        if (appliedFilters.learningCenterCharter) filters.learningCenterCharter = appliedFilters.learningCenterCharter;
        if (appliedFilters.age) filters.age = appliedFilters.age;
        if (appliedFilters.startDate) filters.startDate = appliedFilters.startDate;
        if (appliedFilters.endDate) filters.endDate = appliedFilters.endDate;
      }

      // Add search text only if not empty
      if (searchText && searchText.trim() !== '') {
        filters.searchText = searchText.trim();
      }

      // Reset to page 1 when searching
      setCurrentPage(1);

      // Call backend - this will reload data with or without search text
      getRegistrations(filters);
    }, 500); // 500ms debounce delay

    // Cleanup function
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [searchText]);

  const onChangeText = (e) => {
    const value = e.target.value;
    setSearchText(value);

    // Call parent callback if provided
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const handleClearSearch = () => {
    setSearchText("");
    if (onSearchChange) {
      onSearchChange("");
    }
  };

  return (
    <div className="search-form-container">
      <div className="search-input-wrapper">
        <input
          name="registration-search"
          className="search-input"
          placeholder={placeholderText}
          value={searchText}
          onChange={onChangeText}
        />
        {searchText && (
          <button
            className="clear-search-btn"
            onClick={handleClearSearch}
            type="button"
          >
            <FaIcons.FaTimes />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchForm;

